export default __webpack_public_path__ + "static/media/lawyer_green.154c5baa.svg";